export const routes = (prefix = `auditing`) => [
    {
        name: `${prefix}.consultant-related-services.index`,
        path: `/${prefix}/consultant-related-services`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.consultant-related-services.index`,
                PageDescription: "Audits - Consultant Related Services",
            },
        },
    },
];
